import { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients';

import type { OwnTransportType } from '@libs/trip-planner-interfaces';
import { ConnectionType, TransportType } from '@libs/trip-planner-interfaces';
import { assertValue, DEFAULT_TRANSPORT_TYPE } from '@libs/utils';

import { OWN_TRANSPORT_INGREDIENT_SUFFIX } from './constants';

export function deserializeOwnTransport(value: string): OwnTransportIngredient {
  const { ownTransportConnectionType } = deserializeIngredientParameters(value);
  const deserializedOwnTransportType = deserializeTransportType(
    ownTransportConnectionType
  );
  const ownTransportType = getOwnTransportTypeFromConnectionType(
    deserializedOwnTransportType
  );
  const result = new OwnTransportIngredient(ownTransportType);
  result.ownTransportType = ownTransportType;
  return result;
}

export interface SerializedOwnTransportParameters {
  ownTransportConnectionType: string;
}

export function deserializeIngredientParameters(
  value: string
): SerializedOwnTransportParameters {
  const sanitizedValue = decodeURIComponent(value.replace(/\+/g, ' ')).replace(
    OWN_TRANSPORT_INGREDIENT_SUFFIX,
    ''
  );
  const ownTransportConnectionType = sanitizedValue;

  return {
    ownTransportConnectionType,
  };
}

export function getOwnTransportTypeFromConnectionType(
  transport: ConnectionType
): OwnTransportType {
  switch (transport) {
    case ConnectionType.CAR:
      return TransportType.Car;
    case ConnectionType.BICYCLE:
      return TransportType.Bicycle;
    case ConnectionType.WALK:
      return TransportType.Walk;
    case ConnectionType.NONE:
      return TransportType.None;
    default:
      throw new Error('Invalid connection type for own transport');
  }
}

export function deserializeTransportType(props: string): ConnectionType {
  const firstValue = props[0];
  const secondValue = props[1];
  assertValue(
    firstValue,
    'hotelSerializer.ts > deserializeTransportType > firstValue'
  );
  assertValue(
    secondValue,
    'hotelSerializer.ts > deserializeTransportType > secondValue'
  );

  const result = parseInt(firstValue + secondValue, 10);

  if (isNaN(result)) {
    return DEFAULT_TRANSPORT_TYPE;
  }

  return result;
}
